import React, { useEffect, useState } from "react";
import Dashboard from "../../../dashboard/index.js";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout/index.js";
import {
  Box,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  duration,
  FormControl,
  FormHelperText,
  Grid,
  Grid2,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import MaterialTypography from "../../../../components/MaterialTypography/index.js";
import MaterialButton from "../../../../components/MaterialButton/index.js";
import {
  BsFillPersonBadgeFill,
  BsFillPersonVcardFill,
  BsFillTelephoneFill,
} from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox/index.js";
import MaterialSelect from "../../../../components/MasterSelect/index.js";
import MaterialInput from "../../../../components/MaterialInput/index.js";
import BASEURL from "../../../Utils/Baseurl.js";

import {
  allCustomer,
  allprospect,
  filterorganisationname,
  getAllTask,
  getcalldetails,
  getContactdetail,
  getContactdetails,
  getemaildetails,
  getOrganisationname,
  getOrganisationtype,
  getUserHierarchy,
} from "../../callQuery.js";
import request from "graphql-request";
import { useAuth } from "../../../../context/AuthContext/AuthContextProvider.jsx";
import { fromGlobalId } from "../../../../lib/decoded/rawPk.js";
import {
  addCallService,
  updateCallService,
} from "../../callMutation.js";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog/index.js";
import { useLoading } from "../../../../context/LodingContext.jsx";
import { useSuccess } from "../../../../context/SucccessContext.jsx";
import { useError } from "../../../../context/ErrorContext.jsx";

const AddCall = () => {
  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const params = useLocation();
  const id = params.search.slice(1);
  const today = new Date().toISOString().split("T")[0];
  const useroptions = [
    {
      value: "customer",
      label: "Customer",
    },
    {
      value: "lead and prospect",
      label: "Prospect",
    },
    {
      value: "others",
      label: "Others",
    },
  ];
  const calltype = [
    {
      value: "incoming",
      label: "Incoming",
    },
    {
      value: "outgoing",
      label: "Outgoing",
    },
  ];

  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const [disable, setdisable] = useState(true);
  const [userData, setuserData] = useState([]);
  const [userName, setuserName] = useState([]);
  const [ titleOptions, setTitleOptions ] = useState();
  const [Data, setData] = useState({});
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [isOtherUserType, setIsOtherUserType] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });
  const [ taskData, setTaskData ] = useState({
    taskTitle: "",
    taskTitleStatus: "unchecked"
  });
    
  const [dropOption, setdropOption] = useState([]);
  const navigate = useNavigate();
  const [callData, setcallData] = useState({
    userType: "",
    userTypeStatus: "unchecked",
    name: "",
    nameStatus: "unchecked",
    preparedBy: {
      value: rawPk,
      label: currentUser?.username,
    },
    preparedByStatus: "success",
    callType: "",
    callTypeStatus: "unchecked",
    role: "",
    roleStatus: "unchecked",
    organizationName: "",
    organizationNameStatus: "unchecked",
    contactNumber: "",
    contactNumberStatus: "unchecked",
    callType: "",
    callTypeStatus: "unchecked",
  });

  const [selectedtData, setSelectedData] = useState([]);
  const [callfieldData, setcallfieldData] = useState({
    startDate: today,
    startDateStatus: "unchecked",
    startTime: "",
    startTimeStatus: "unchecked",
    duration: "",
    durationStatus: "unchecked",
    description: "",
    descriptionStatus: "unchecked",
    organizationName: "",
    organizationNameStatus: "unchecked",
    name: "",
    nameStatus: "unchecked",
    role: "",
    roleStatus: "unchecked",
    contactNumber: "",
    contactNumberStatus: "unchecked",

  });

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    fetchAllTask();
  },[]);

  //useEffect to fetch Hierarchy
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await request(BASEURL, getUserHierarchy, {
          id: rawPk,
        });
        setdropOption(response?.getUserHierarchy);
      } catch (err) {
        console.error("Error", err);
      }
    };
    fetchdata();
  }, []);

  useEffect(() => {
    let prevState = { ...callfieldData };

    prevState.startDateStatus = "success";
    setcallfieldData(prevState);
  }, []);

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);

  //Fetch Task Title
  const fetchAllTask = async() => {
    try{
      const response = await request(BASEURL, getAllTask);
      const data = response?.allTasks?.data;
      const options = data?.map((task) => ({
        label: task.title,
        value: task.id,
      }));
      setTitleOptions(options);
      
    }
    catch(error){
      console.error("Error Fetching Data", error);
    }
  }

    //Fecth Data By ID
    const fetchUpdateValue = async () => {
      try {
        const res = await request(BASEURL, getcalldetails, {
          id: id,
        });
        const J = res.getCalldetailsById;        
        if (J.userType == "others") {
          setIsOtherUserType(true);
          setcallData({
            userType: {
              value: J.userType,
              label: J.userType,
            },
            role: J.role,
  
            name: {
              value: J.name,
              label: J.name,
            },
            preparedBy: {
              value: J.prefferedBy?.id,
              label: J.prefferedBy?.username,
            },
            callType: {
              value: J.callType,
              label: J.callType,
            },
  
            organizationName: J.organization,
            contactNumber: J.phoneNo,
  
            userTypeStatus: "success",
            roleStatus: "success",
            nameStatus: "success",
            preparedByStatus: "success",
            callTypeStatus: "success",
            organizationNameStatus: "success",
            contactNumberStatus: "success",
            startDateStatus: "success",
            durationStatus: "success",
            descriptionStatus: "success",
            startTimeStatus: "success",
          });
          setTaskData({
            taskTitle: {
              value: J.task.id,
              label: J.task.title,
            },
            taskTitleStatus: J.task.id ? "success" : "unchecked"
          })
  
          setTimeout(() => {
            setcallfieldData({
              ...callfieldData,
              organizationName: J.organization,
              name: J.name,
              role: J.role,
              contactNumber: J.phoneNo,
              startDate: J.callstartDate,
              startTime: J.callstartTime,
              duration: J.callDuration,
              description: J.callDescription,
              organizationNameStatus: "success",
              contactNumberStatus: "success",
              roleStatus: "success",
              nameStatus: "success",
              startDateStatus: "success",
              durationStatus: "success",
              descriptionStatus: "success",
              startTimeStatus: "success",
            });
          }, 500);
        } else {
          setTaskData({
            taskTitle: {
              value: J.task.id,
              label: J.task.title,
            },
            taskTitleStatus: J.task.id ? "success" : "unchecked"
          })
          setcallData({
            userType: {
              value: J.userType,
              label: J.userType,
            },
            role: J.role,
  
            name: {
              value: J.name,
              label: J.name,
            },
            preparedBy: {
              value: J.prefferedBy?.id,
              label: J.prefferedBy?.username,
            },
            callType: {
              value: J.callType,
              label: J.callType,
            },
  
            organizationName: {
              value: J.organization,
              label: J.organization,
            },
            contactNumber: J.phoneNo,
            startDate: J.callstartDate,
            startTime: J.callstartTime,
            duration: J.callDuration,
            description:J.callDescription,
            userTypeStatus: "success",
            roleStatus: "success",
            nameStatus: "success",
            preparedByStatus: "success",
            callTypeStatus: "success",
            organizationNameStatus: "success",
            contactNumberStatus: "success",
            startDateStatus: "success",
            durationStatus: "success",
            descriptionStatus: "success",
            startTimeStatus: "success",
          });
          setData({
            role: J.role,
            contactNumber: J.phoneNo,
          })
          setcallfieldData({
            startTime: J.callstartTime,
            duration: J.callDuration,
            startDate: J.callstartDate,
            description:J.callDescription,
            startTimeStatus: "success",
            durationStatus: "success",
            startDateStatus:"success",
            descriptionStatus: "success",
          })
        }
  
        setSelectedData(J);
      } catch (err) {
        console.error(err.message, "err");
      }
    };

  //Create Mutation
  const handleAddCall = async () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: async () => {
 
          const values = {
            userId: rawPk,
            userType: callData.userType?.label,
            name:
              callData.userType.value == "others"
                ? callfieldData.name
                :callData.name?.label,
 
            role:
              callData.userType.value == "others"
                ? callfieldData.role
                : Data.role,
            organization:
              callData.userType.value == "others"
                ? callfieldData.organizationName
                : callData.name?.label,
            phoneNo:
              callData.userType.value == "others"
                ? callfieldData.contactNumber
                : Data.contactNumber,
            prefferedById: callData.preparedBy?.value,
            callstartDate: callfieldData.startDate,
            callstartTime: callfieldData.startTime,
            callDuration: callfieldData.duration,
            callType: callData.callType?.label,
            callDescription: callfieldData.description,
            taskId: taskData.taskTitle?.value,
          };
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setCirleLoading(true);
          const callStatus = await addCallService(values);
          setCirleLoading(false);
          if (callStatus) {
            setSuccessStatus(true);
            setSucessTitle("Call Log Created");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/call-details");
            }, 1000);
          } else {
            setErrorStatus(true);
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
 
   //Update Mutation
   const handleUpdateCall = () => {
     setConfirmationDialog({
       open: true,
       title: "Confirmation",
       message: "Are you sure do you want to Edit your details.",
       showCancel: true,
       showConfirm: true,
 
       onConfirm: async () => {
         setConfirmationDialog({
           ...confirmationDialog,
           open: false,
         });
         const values = {
           userType: callData.userType?.label,
           name:
             callData.userType.value == "others"
               ? callfieldData.name
               : callData.name?.label,
 
           role:
             callData.userType.value == "others"
               ? callfieldData.role
               : Data.role,
           organization:
             callData.userType.value == "others"
               ? callfieldData.organizationName
               : callData.organizationName?.label,
           phoneNo:
             callData.userType.value == "others"
               ? callfieldData.contactNumber
               : Data.contactNumber,
           prefferedById: callData.preparedBy?.value,
           callstartDate: callfieldData.startDate,
           callstartTime: callfieldData.startTime,
           callDuration: callfieldData.duration,
           callType: callData.callType?.label,
           callDescription: callfieldData.description,
           taskId: taskData.taskTitle?.value,
         };
 
         setConfirmationDialog({
           ...confirmationDialog,
           open: false,
         });
         setCirleLoading(true);
         const updateStatus = await updateCallService(id, values);
         setCirleLoading(false);
         if (updateStatus) {
           setSuccessStatus(true);
           setSucessTitle("Call Log Updated");
           setTimeout(() => {
             setSuccessStatus(false);
             navigate("/call-details");
           }, 1000);
         } else {
           setErrorStatus(true);
           setTimeout(() => {
             setErrorStatus(false);
           }, 3000);
         }
       },
       onCancel: () => {
         setConfirmationDialog({
           ...confirmationDialog,
           open: false,
         });
       },
     });
   };

  //Cancel Function
  const handleCancelCallData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        navigate("/call-details");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    if (selectedtData.userType == "others") {
      setIsOtherUserType(true);
      setcallData({
        userType: {
          value: selectedtData.userType,
          label: selectedtData.userType,
        },
        role: selectedtData.role,

        name: {
          value: selectedtData.name,
          label: selectedtData.name,
        },
        preparedBy: {
          value: selectedtData.prefferedBy?.id,
          label: selectedtData.prefferedBy?.username,
        },
        callType: {
          value: selectedtData.callType,
          label: selectedtData.callType,
        },

        organizationName: selectedtData.organization,
        contactNumber: selectedtData.phoneNo,

        userTypeStatus: "success",
        roleStatus: "success",
        nameStatus: "success",
        preparedByStatus: "success",
        callTypeStatus: "success",
        organizationNameStatus: "success",
        contactNumberStatus: "success",
        startDateStatus: "success",
        durationStatus: "success",
        descriptionStatus: "success",
        startTimeStatus: "success",
      });
      setTaskData({
        taskTitle: {
          value: selectedtData.task.id,
          label: selectedtData.task.title,
        },
        taskTitleStatus: selectedtData.task.id ? "success" : "unchecked"
      })

      setTimeout(() => {
        setcallfieldData({
          ...callfieldData,
          organizationName: selectedtData.organization,
          name: selectedtData.name,
          role: selectedtData.role,
          contactNumber: selectedtData.phoneNo,
          startDate: selectedtData.callstartDate,
          startTime: selectedtData.callstartTime,
          duration: selectedtData.callDuration,
          description: selectedtData.callDescription,
          organizationNameStatus: "success",
          contactNumberStatus: "success",
          roleStatus: "success",
          nameStatus: "success",
          startDateStatus: "success",
          durationStatus: "success",
          descriptionStatus: "success",
          startTimeStatus: "success",
        });
      }, 500);
    } else {
      setcallData({
        userType: {
          value: selectedtData.userType,
          label: selectedtData.userType,
        },
        role: selectedtData.role,

        name: {
          value: selectedtData.name,
          label: selectedtData.name,
        },
        preparedBy: {
          value: selectedtData.prefferedBy?.id,
          label: selectedtData.prefferedBy?.username,
        },
        callType: {
          value: selectedtData.callType,
          label: selectedtData.callType,
        },

        organizationName: {
          value: selectedtData.organization,
          label: selectedtData.organization,
        },
        contactNumber: selectedtData.phoneNo,
        startDate: selectedtData.callstartDate,
        startTime: selectedtData.callstartTime,
        duration: selectedtData.callDuration,
        userTypeStatus: "success",
        roleStatus: "success",
        nameStatus: "success",
        preparedByStatus: "success",
        callTypeStatus: "success",
        organizationNameStatus: "success",
        contactNumberStatus: "success",
        startDateStatus: "success",
        durationStatus: "success",
        descriptionStatus: "success",
        startTimeStatus: "success",
      });
     
    }
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      callData.userTypeStatus === "success" &&
      callData.preparedByStatus === "success" &&
      callData.callTypeStatus === "success" &&
      callfieldData.startDateStatus === "success" &&
      callfieldData.startTimeStatus === "success" &&
      callfieldData.durationStatus === "success" &&
      (isOtherUserType
        ? callfieldData.organizationNameStatus === "success" &&
        callfieldData.contactNumberStatus === "success"  
        : callData.organizationNameStatus === "success" &&
        callData.contactNumberStatus === "success" )
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Handle Change with selectEvent
  const handleCallDataChange = (event, selectEvent) => {
    let callState = { ...callData };
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "userType":
          {
            if (event.value === "others") {
              setIsOtherUserType(true);

              callState["role"] = "";
              callState["contactNumber"] = "";
              callState["name"] = "";
              callState["organizationName"] = "";
              callState["roleStatus"] = "unchecked";
              callState["contactNumberStatus"] = "unchecked";
              callState["nameStatus"] = "unchecked";
              callState["organizationNameStatus"] = "unchecked";

              setData({
                contactNumber: "",
                role: "",
              });
            } else {
              setIsOtherUserType(false);
            }
            if (event.value === "customer") {
              request(BASEURL, allCustomer, {
                organization: "customer",
              })
                .then((res) => {
                  setuserData(res.allCustomer);
                })
                .catch(() => {
                  callState["nameStatus"] = "unchecked";
                  callState["name"] = "";
                });
            } else if (event.value === "lead and prospect") {
              request(BASEURL, allprospect, {
                organization: "lead and prospect",
              }).then((res) => {
                setuserData(res.allLeadprospect);
              });
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              callState["userTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
              callState["nameStatus"] = "unchecked";
              callState["name"] = "";
            
              callState["roleStatus"] = "unchecked";
              callState["organizationName"] = "";
              callState["organizationNameStatus"] = "unchecked";
              callState["contactNumber"] = "";
              callState["contactNumberStatus"] = "unchecked";
              setData({
                contactNumber: "",
                role: "",
              });
            } else {
              callState["userTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
              callState["nameStatus"] = "unchecked";
              callState["name"] = "";

              callState["roleStatus"] = "unchecked";
              callState["organizationName"] = "";
              callState["organizationNameStatus"] = "unchecked";
              callState["contactNumber"] = "";
              callState["contactNumberStatus"] = "unchecked";
            }
          }
          break;

        case "name":
          {
            if (event?.label !== undefined) {
              request(BASEURL, getContactdetails, { id: event.value })
                .then((res) => {

                  setData(res?.getContactdetail);
                })
                .catch((error) => {});
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label)) {
              callState["nameStatus"] = "success";
              callState["roleStatus"] = "success";
              callState["contactNumberStatus"] = "success";
            } else {
              setcallData({
                ...callData,
                nameStatus: selectEvent.value === "" ? "unchecked" : "error",
              });
            }
          }
          break;
        case "preparedBy":
          {
            const lengthRegex = new RegExp("^[\\s\\S]*$");
            if (lengthRegex.test(event?.label) === true) {
              callState["preparedByStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              callState["preparedByStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "callType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              callState["callTypeStatus"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              callState["callTypeStatus"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "organizationName": {
          if (event?.label !== undefined) {
            request(BASEURL, getOrganisationname, {
              organisationname: event.label,
            }).then((res) => {
              setuserName(res.getOrganisationname);
            });
          }
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.value) === true) {
            callState["organizationNameStatus"] = "success";
          }
        }
      }

      callState[selectEvent.name] = event;
    }
    setcallData(callState);
  };

  //Handle Change without selectEvent
  const handleCallChange = (event) => {

    let prevState = { ...callfieldData };
    switch (event.target.name) {
      case "startDate":
        prevState[event.target.name] = event.target.value;
        prevState[event.target.name + "Status"] = "success";
        break;

      case "startTime":
        prevState[event.target.name + "Status"] = event.target.value
          ? "success"
          : "error";
        break;

      case "startTime": {
        if (event?.target.value) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] = "error";
        }
        break;
      }
      case "duration": {
        const alphaNLenghthRegex = new RegExp("^.{2,50}$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "organizationName": {
        // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";

        // Only validate if there's input
        if (trimmedValue !== "") {
          // Check if input contains any numbers (using a regex for numbers)
          const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

          if (containsNumbers) {
            prevState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            prevState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should be  30 characters long";
          } else {
            prevState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          prevState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        prevState[event.target.name + "ErrorMessage"] = errorMessage;
        break;
      }
      case "name": {
        // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";

        // Only validate if there's input
        if (trimmedValue !== "") {
          // Check if input contains any numbers (using a regex for numbers)
          const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

          if (containsNumbers) {
            prevState[event.target.name + "Status"] = "error";
            errorMessage = " Name should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            prevState[event.target.name + "Status"] = "error";
            errorMessage = " Name should be and 30 characters long";
          } else {
            prevState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          prevState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        prevState[event.target.name + "ErrorMessage"] = errorMessage;
        break;
      }
      case "role": {
        const alphaNLenghthRegex = new RegExp("^.{2,35}$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "contactNumber": {
        const numericRegex = new RegExp("^[0-9]{2,15}$");
        if (numericRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }

      case "description": {
        const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,500}$");
        if (alphaNLenghthRegex.test(event.target.value?.trim())) {
          prevState[event.target.name + "Status"] = "success";
        } else {
          prevState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
    }
    if (event.target.name !== "startDate") {
      prevState[event.target.name] = event.target.value;
    }
    setcallfieldData(prevState);
  };

  //Handle change for Task Title
  const handleTaskTitle = (event, selectEvent) => {
    let taskStatusState = { ...taskData };
    if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "taskTitle": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }
      }
      taskStatusState[selectEvent.name] = event;
    }
    setTaskData(taskStatusState);
  };  

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true  ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Call Log details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      size='small'
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) :togglePage.edit === true? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Call Log
                    </MaterialTypography>
                  
                  </Stack>
                  <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                </Stack>
              ):(  <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h6" fontWeight="medium">
                    Add Call Log
                  </MaterialTypography>
                </Stack>
              </Stack>)}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
         <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                 <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                 <MaterialTypography
                                 sx={{color:'#460058',fontFamily:'Aptos'}}
                                   component="label"
                                   variant="body2"
                                   fontWeight="700"
                                 >
                                  Customer / Prospect Information
                                 </MaterialTypography>
                               </Stack>
          <MaterialBox>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    User Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="userType"
                  value={callData.userType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleCallDataChange}
                  options={useroptions?.map((item) => {
                    return {
                      value: item?.value,
                      label: item?.label,
                    };
                  })}
                  error={callData.userTypeStatus === "error" ? true : false}
                  success={callData.userTypeStatus === "success" ? true : false}
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Organization Name<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <>
                  <MaterialInput
                    name="organizationName"
                    placeholder=" Organization Name..."
                    value={callfieldData.organizationName}
                    onChange={handleCallChange}
                    error={callfieldData.organizationNameStatus === "error"}
                    success={callfieldData.organizationNameStatus === "success"}
                    disabled={togglePage?.view === true ? true : false}
                  />
                  {callfieldData.organizationNameStatus === "error" &&
                                          callfieldData.organizationNameErrorMessage && (
                                            <FormControl error>
                                              <FormHelperText>
                                                {callfieldData.organizationNameErrorMessage}
                                              </FormHelperText>
                                            </FormControl>
                                          )}
                                      </>
                ) : (
                  <MaterialSelect
                    name="organizationName"
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallDataChange}
                    value={callData.organizationName}
                    options={userData?.map((item) => {
                      return {
                        value: item?.id,
                        label: item?.legalName || item?.companyName,
                      };
                    })}
                    error={
                      callData.organizationNameStatus === "error" ? true : false
                    }
                    success={
                      callData.organizationNameStatus === "success"
                        ? true
                        : false
                    }
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <>
                  <MaterialInput
                    name="name"
                    placeholder=" Name..."
                    value={callfieldData.name}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallChange}
                    error={callfieldData.nameStatus === "error"}
                    success={callfieldData.nameStatus === "success"}
                    disabled={togglePage?.view === true ? true : false}
                  />
                   {callfieldData.nameStatus === "error" &&
                    callfieldData.nameErrorMessage && (
                                            <FormControl error>
                                              <FormHelperText>
                                                {callfieldData.nameErrorMessage}
                                              </FormHelperText>
                                            </FormControl>
                                          )}
                                          </>
                ) : (
                  <MaterialSelect
                    name="name"
                    value={callData.name}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallDataChange}
                    options={userName?.map((item) => {
                      return {
                        value: item?.id,
                        label: item?.firstName,
                      };
                    })}
                    error={callData.nameStatus === "error" ? true : false}
                    success={callData.nameStatus === "success" ? true : false}
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <MaterialInput
                    name="role"
                    placeholder="Role..."
                    value={callfieldData.role || ""}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallChange}
                    error={callfieldData.roleStatus === "error" ? true : false}
                    success={
                      callfieldData.roleStatus === "success" ? true : false
                    }
                    disabled={togglePage?.view === true ? true : false}
                  />
                ) : (
                  <>
                
                  <MaterialInput
                  
                    name="role"
                    placeholder="Role..."
                    value={Data?.role || ""}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallDataChange}
                    error={callData.roleStatus === "error" ? true : false}
                    success={callData.roleStatus === "success" ? true : false}
                    disabled={true}
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                  </>
                )}
              </Grid2>

              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <>
                    <MaterialInput
                      name="contactNumber"
                      placeholder="Contact..."
                      value={callfieldData.contactNumber}
                      customStyles={{ optionPadding: 20 }}
                      onChange={handleCallChange}
                      error={
                        callfieldData.contactNumberStatus === "error"
                          ? true
                          : false
                      }
                      success={
                        callfieldData.contactNumberStatus === "success"
                          ? true
                          : false
                      }
                      disabled={togglePage?.view === true ? true : false}
                    />
                    {callfieldData.contactNumberStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Please enter a valid contact number
                        </FormHelperText>
                      </FormControl>
                    )}
                  </>
                ) : (
                  <MaterialInput
                    name="contactNumber"
                    placeholder="Contact..."
                    value={Data.contactNumber}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleCallDataChange}
                    error={
                      callData.contactNumberStatus === "error" ? true : false
                    }
                    success={
                      callData.contactNumberStatus === "success" ? true : false
                    }
                    disabled={true}
                    isDisabled={togglePage?.view === true ? true : false}
                  />
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Associated By <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="preparedBy"
                  customStyles={{ optionPadding: 20 }}
                  value={callData.preparedBy}
                  onChange={handleCallDataChange}
                  options={dropOption?.map((item) => {
                    return {
                      value: item?.id,
                      label: item?.username,
                    };
                  })}
                  error={callData.preparedByStatus === "error" ? true : false}
                  success={
                    callData.preparedByStatus === "success" ? true : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Task Title <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="taskTitle"
                  customStyles={{ optionPadding: 20 }}
                  value={taskData.taskTitle}
                  onChange={handleTaskTitle}
                  options={titleOptions}
                  error={taskData.taskTitleStatus === "error" ? true : false}
                  success={
                    taskData.taskTitleStatus === "success" ? true : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
            </Grid2>
            <Divider />
               <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                 <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                 <MaterialTypography
                                 sx={{color:'#460058',fontFamily:'Aptos'}}
                                   component="label"
                                   variant="body2"
                                   fontWeight="700"
                                 >
                                   Call Information
                                 </MaterialTypography>
                               </Stack>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Call Start Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startDate"
                  type="date"
                  placeholder="eg.01-01-2024"
                  value={callfieldData.startDate}
                  onChange={handleCallChange}
                  inputProps={{
                    min: new Date(new Date().setDate(new Date().getDate() - 7)) // 7 days before today
                      .toISOString()
                      .split("T")[0],
                    max: new Date().toISOString().split("T")[0],
                  }}
                  error={
                    callfieldData.startDateStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.startDateStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Call Start Time <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="startTime"
                  type="time"
                  placeholder="eg. 10:30"
                  value={callfieldData.startTime}
                  onChange={handleCallChange}
                  error={
                    callfieldData.startTimeStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.startTimeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Call Duration<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="duration"
                  placeholder="eg. 2Hours 20Mins "
                  value={callfieldData.duration}
                  onChange={handleCallChange}
                  error={
                    callfieldData.durationStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.durationStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {callfieldData.durationStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Call Duration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Call Type <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="callType"
                  value={callData.callType}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleCallDataChange}
                  options={calltype?.map((item) => {
                    return {
                      value: item?.value,
                      label: item?.label,
                    };
                  })}
                  error={callData.callTypeStatus === "error" ? true : false}
                  success={callData.callTypeStatus === "success" ? true : false}
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  placeholder="Write description..."
                  multiline
                  rows={3}
                  value={callfieldData.description}
                  onChange={handleCallChange}
                  error={
                    callfieldData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    callfieldData.descriptionStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {callfieldData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description Should be maximum 50 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
            </Grid2>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={handleDiscardButton}
                  >
                    Discard
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleUpdateCall}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleAddCall}
                  >
                    Submit
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handleCancelCallData}
                  >
                    Cancel
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AddCall;
